import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';
import { Grid, Button, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import LoginNameSettings from './LoginName';
import PasswordSettings from './Password';
import Language from './Language';
import Notifications from './Notifications';
import Header from '../Header/Header';

import { fetchEmployeeData } from '../../actions/employee.action';

const SettingsPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [ drawerOpen, setDrawerOpen ] = useState(false);

  const useStyles = makeStyles({
    root: {
      margin: '30px auto',
      width: '280px'
    },
    divider: {
      margin: '20px 0'
    },
    button: {
      border: '#99B64E solid 2px',
      boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3)',
      borderRadius: '4px',
      marginTop: '12px'
    }
  });

  useEffect(() => {
    dispatch(fetchEmployeeData());
  }, [ dispatch ]);

  const classes = useStyles();

  return (
    <>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      <div className={ classes.root }>
        <Grid
          container
          direction="column"
          justifyContent="center"
          spacing={ 3 }
        >
          <Notifications/>
          <Divider className={ classes.divider }/>
          <LoginNameSettings/>
          <Divider className={ classes.divider }/>
          <Language/>
          <Divider className={ classes.divider }/>
          <PasswordSettings/>
          <Button
            className={ `${classes.button} back-to-goals` }
            component={ Link }
            to="/objectives"
            color="primary"
          >
            { t('settings.backButton') }
          </Button>
        </Grid>
      </div>
    </>
  );
};

export default SettingsPage;
